module.exports = __webpack_public_path__ + "static/cam_x_theo-5079adc0403779f121e4a689785bef57.svg";